import { render } from "./LastTransactionsTable.vue?vue&type=template&id=c60d9044&scoped=true"
import script from "./LastTransactionsTable.vue?vue&type=script&lang=js"
export * from "./LastTransactionsTable.vue?vue&type=script&lang=js"

import "./LastTransactionsTable.vue?vue&type=style&index=0&id=c60d9044&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c60d9044"]])

export default __exports__